/**
 * Initialize all general Swipers on the page.
 * Excludes swipers handled by specific methods (testimonials, wp-swiper).
 */
export function initClientLogosSwiper() {
  // Find all general swiper containers (excluding testimonials and wp-swiper which have their own methods)
  const swiperContainers = document.querySelectorAll('.swiper-container:not(.buckup-testimonials-container):not(.wp-swiper .swiper-container)');

  swiperContainers.forEach(container => {

    // Basic configuration for general swipers
    new window.Swiper(container, {
      // modules are already configured in app.js via Swiper.use()
      slidesPerView: 'auto',
      spaceBetween: 30,
      centeredSlides: true,
      initialSlide: 4,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: container.parentElement.querySelector('.swiper-button-next'),
        prevEl: container.parentElement.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: container.parentElement.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
        480: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 1,
        },
      },
    });
  });
}